import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core/react/i18n';

export const PayWithCreditCardOrPaypalText: React.FC = () => {
	return (
		<div className="flex justify-center">
			<Text className="text-typography-secondary">
				<TranslateHtml
					value="corgi.membership.ask.pay_with"
					replacements={{
						paypalImageElement: (
							<Image
								alt="paypal"
								className="inline aspect-auto h-4.5 w-auto md:h-5"
								src="https://static.change.org/payment-options/paypal-wordmark.png"
							/>
						),
					}}
				/>
			</Text>
		</div>
	);
};
